import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3dada0e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "variant-selector-item" };
const _hoisted_2 = {
    key: 0,
    class: "default"
};
import { ElCheckbox } from "element-plus";
import { computed, toRef } from "vue";
import { useCampaignWorkingVariants } from "../composables/useCampaignWorkingVariants";
import { useCampaignVariants } from "src/shared/store/campaign-built/composables/useCampaignVariants";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DisplayedCampaignVariantSelectorItem',
    props: {
        campaignId: {},
        variant: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { toggleWorkingVariant, isWorkingVariantActive } = useCampaignWorkingVariants(props.campaignId);
        const { defaultVariant } = useCampaignVariants(toRef(props, "campaignId"));
        const isDisplayed = computed({
            get: () => {
                return isWorkingVariantActive(props.variant);
            },
            set: () => {
                toggleWorkingVariant(props.variant);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createVNode(_unref(ElCheckbox), {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                    label: _ctx.variant,
                    modelValue: isDisplayed.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isDisplayed).value = $event))
                }, null, 8 /* PROPS */, ["label", "modelValue"]),
                (_unref(defaultVariant) === _ctx.variant)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "default"))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
